import React from "react";
import Section from "./Section";
import Container from "react-bootstrap/Container";
import SectionHeader from "./SectionHeader";
import Features from "./Features";

function FeaturesSection(props) {
  return (
    <Section
      bg={props.bg}
      textColor={props.textColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container>
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={2}
          spaced={true}
          className="text-center"
        />
        <Features
          items={[
            {
              title: "Know Yourself",
              description:
                "Take the big five personality test and get to know how your personality might give you an advantage in certain roles.",
              image: "img/undraw-mind_map_cwng.svg",
              link: "https://www.bigfive.juniormentorship.com"
            },
            {
              title: "Build a Foundation",
              description:
                "Through a combination of selfstudy, group work and one on one learning programs.",
              image:
                "img/undraw-personal_settings_kihd.svg",
              link: null,
            },
            {
              title: "Mentorship",
              description:
                "Once you have a foundation, we'll embark on a one on one project where you'll be guided into building a project realted to your ideal role.",
              image: "img/undraw-balloons_vxx5.svg",
              link: null,
            },
            {
              title: "Get Hired",
              description:
                "Through a series of introdcutions and hiring tips, we'll help you find the right role and support you during your onboarding.",
              image: "img/undraw-having_fun_iais.svg",
              link: null,
            },
          ]}
        />
      </Container>
    </Section>
  );
}

export default FeaturesSection;
